// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"425":"2eca4270","534":"ac4a0ff8","630":"19eac67a","818":"c5aedaff"}[chunkId] + ".chunk.js";
};